var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1998 7.9998C15.1998 11.9763 11.9762 15.1998 7.99979 15.1998C4.02335 15.1998 0.799805 11.9763 0.799805 7.9998C0.799805 4.02335 4.02335 0.799805 7.99979 0.799805C11.9762 0.799805 15.1998 4.02335 15.1998 7.9998ZM9.79978 5.2998C9.79978 6.29392 8.9939 7.0998 7.99979 7.0998C7.00568 7.0998 6.19979 6.29392 6.19979 5.2998C6.19979 4.30569 7.00568 3.4998 7.99979 3.4998C8.9939 3.4998 9.79978 4.30569 9.79978 5.2998ZM7.99973 8.89981C6.18394 8.89981 4.61935 9.97526 3.90816 11.524C4.89842 12.6726 6.36418 13.3998 7.99977 13.3998C9.63533 13.3998 11.1011 12.6727 12.0913 11.524C11.3802 9.9753 9.81554 8.89981 7.99973 8.89981Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.01a128f432aa689d995d7bc6ce9bc318.svg";
export { ForwardRef as ReactComponent };